"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var LoadSVG = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(LoadSVG, _React$Component);

  function LoadSVG() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = LoadSVG.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        src = _this$props.src,
        colour = _this$props.colour,
        alt = _this$props.alt,
        title = _this$props.title;

    if (!src) {
      return null;
    }

    var extension = src.split('.').pop();

    switch (extension) {
      case 'svg':
        return /*#__PURE__*/React.createElement("span", {
          className: "landing-page--svg-wrapper",
          style: {
            fill: colour,
            stroke: colour
          }
        }, /*#__PURE__*/React.createElement(_reactInlinesvg["default"], {
          src: src,
          "aria-label": alt
        }));

      case 'png':
      case 'jpg':
      case 'jpeg':
        return /*#__PURE__*/React.createElement("img", {
          src: src,
          alt: alt,
          title: title
        });

      default:
        return null;
    }
  };

  return LoadSVG;
}(React.Component);

var _default = LoadSVG;
exports["default"] = _default;